import { ToolboxAnalyticsSection } from './toolbox-analytics-section';

export function ToolboxAnalyticsPage() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 max-w-6xl mx-auto">
      <ToolboxAnalyticsSection />
    </div>
  );
}
